import { useState, useEffect } from "react";
import { fetchWithToken } from "../utils/fetchWithToken";
import "../assets/css/Settings.css";

function Settings() {
  const agencyId = sessionStorage.getItem("REACT_APP_AGENCY_ID");
  const token = sessionStorage.getItem("REACT_APP_TOKEN");

  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    clientId: "",
    file: null,
    period: "",
  });

  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetchWithToken("https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/clients/list");
        const data = await response.json();

        const clientsRaw = data?.clients || [];
        const filteredClients = clientsRaw.filter(client => client.agencyId === agencyId);
        const uniqueClients = filteredClients.reduce((acc, client) => {
          if (!acc.find(c => c.nome === client.nome)) {
            acc.push(client);
          }
          return acc;
        }, []);

        setClients(uniqueClients);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error.message);
      }
    };

    fetchClients();
  }, []);

  const validateForm = () => {
    if (!formData.clientId || !agencyId || !formData.file || !formData.period) {
      setServerError("Preencha todos os campos.");
      return false;
    }

    if (formData.file && formData.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      setServerError("O arquivo precisa ser .xlsx");
      return;
    }

    return true;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const form = new FormData();
    form.append("file", formData.file);
    form.append("clientId", formData.clientId);
    form.append("agencyId", agencyId);
    form.append("periodo", formData.period);

    try {
      const response = await fetch(
        "https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/file/spreadsheet",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        }
      );
      const result = await response.json();

      if (response.ok) {
        setSuccessMessage("Arquivo enviado com sucesso!");
        showNotification("Arquivo enviado com sucesso!", "success");
      } else {
        setServerError(result.message || "Erro ao enviar.");
        setSuccessMessage("");
        showNotification(result.error, "error");
      }
    } catch (error) {
      console.error("Erro ao enviar arquivo:", error);
      setServerError("Erro inesperado. Tente novamente mais tarde.");
      showNotification("Erro inesperado. Tente novamente mais tarde.", "error");
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (message, type = "success") => {
    const notification = document.createElement("div");
    notification.className = `refresh-notification ${type}`;

    const icon = type === "success" ? "ti ti-check" : "ti ti-x";

    notification.innerHTML = `
    <i class="${icon}"></i>
    <span>${message}</span>
  `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.classList.add("show");
    }, 10);

    setTimeout(() => {
      notification.classList.remove("show");
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  };

  const isFormValid =
    formData.clientId &&
    agencyId &&
    formData.file &&
    formData.file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
    formData.period;

  return (
    <div className="settings-container">
      <div className="settings-content">
        <div className="settings-panel">
          <div className="connected-sources">
            <div className="sources-header">
              <h2>Upload de campanhas</h2>
              <p>Conecte e gerencie as fontes de dados do seu cliente</p>
            </div>

            <form onSubmit={handleSubmit} className="settings-form">
              <input type="hidden" className="input-modal" name="clientId" value={formData.clientId} />

              <label className="data-source-label" htmlFor="clientId-select">Cliente:</label>
              <select
                id="clientId-select"
                className="input-modal"
                name="clientId"
                value={formData.clientId}
                onChange={handleChange}
                required
              >
                <option value="">Selecione um cliente</option>
                {clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.nome}
                  </option>
                ))}
              </select>

              <label className="data-source-label" htmlFor="period-input">Período:</label>
              <input id="period-input" type="month" className="input-modal" name="period" value={formData.period} onChange={handleChange} required />

              <label className="data-source-label" htmlFor="file-upload">Arquivo (upload):</label>
              <input id="file-upload" type="file" className="input-modal" name="file" accept=".xlsx" onChange={handleChange} />

              <div className="navigation-container" style={{ marginTop: "40px" }}>
                <button
                  type="submit"
                  className={`login-button ${!isFormValid || loading ? "button-disabled" : ""}`}
                  disabled={!isFormValid || loading}
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
